module.exports = __webpack_public_path__ + "static/signature-static-1ef9b2e3633f8f3cfe1bf43540fa2763.png";